import React from 'react'
import { useSelector } from 'hooks'
import { Button, T, Link } from 'components'
import StyledSuccess from './StyledSuccess'
import SuccessImage from 'assets/images/payment-success.svg'

const Success = () => {
  const siteName = useSelector(s => s.siteConfig.siteName)

  return (
    <StyledSuccess className="inner">
      <img className="status-img" alt="Payment successful" src={SuccessImage} />
      <T as="h1" className="title success" label="payment/upgradeSuccess" />
      <p>
        <T label="payment/thankYouForUpgrading" /> {siteName}
      </p>
      <T as="p" label="payment/paymentIsProcessed" />
      <p>
        <T label="payment/ifDontReceiveEmail" /> <T as={Link} to="/contacts" label="payment/contactSupport" />
      </p>
      <Button color="cta" className="action" to="/" label="payment/continueBrowsing" />
      <p>
        <T label="payment/thanksForChoosing" /> {siteName}
        <T label="payment/hopeYouEnjoy" />
      </p>
    </StyledSuccess>
  )
}

export default Success
